import { createFileRoute } from "@tanstack/react-router";

import { Centered } from "@/components/ui/container";
import { apiUtils } from "@/context/query";

export const Route = createFileRoute("/_auth/_app/subjects/$id/create")({
  beforeLoad: async ({ params, context }) => {
    if (
      !context.user.hasRole([
        "blis_org_tech",
        "blis_lab_assistant",
        "blis_lab_tech",
        "blis_lab_manager",
      ])
    ) {
      throw new Error("Unauthorized");
    }
  },
  loader: async ({ params }) => {
    const [orgId] = await Promise.all([
      apiUtils.orgs.guessOrg.ensureData({
        subjectId: params.id,
      }),
      apiUtils.orgs.primaryOrgsList.ensureData(),
    ]);
    return { orgId };
  },
  errorComponent: ({ error }) => <Centered>{error.message}</Centered>,
});
